"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNumber = _interopRequireDefault(require("./isNumber"));

/*
* @function parseFloatElseNull
* @param  {string} value The value to parse. If the string argument is not a string, then it is converted
* to a string (using the ToString abstract operation). Leading whitespace in the string argument is ignored.
* @return {(null|number)} parsed float, or null if we could not parse it
*/
var parseFloatElseNull = function parseFloatElseNull(value) {
  var floatConversion = parseFloat(value);
  return (0, _isNumber["default"])(floatConversion) ? floatConversion : null;
};

var _default = parseFloatElseNull;
exports["default"] = _default;